<ng-container *ngIf="viewModel$ | async as vm">
  <div class="factors-container">
    <div class="is-flex has-spacing-bottom-m">
      <app-text class="text-18 is-family-semiBold">{{"common-app.__EXPLANATORY_FACTORS" | AsyncLang | async}}</app-text>
      <app-icon name="information" class="text-24 text-grey-50 has-spacing-left-s is-cursor-pointer" (click)="setInfo()"></app-icon>
    </div>
   
    @if(isInfoOpen()) {
      <app-information-popup>
        <div role="content">
          <app-text class="text-18 is-family-semiBold has-spacing-bottom-xl is-justify-center">{{'common-app.__EXPLANATORY_FACTORS_INFO_TITLE' | AsyncLang | async }}</app-text>
          <app-text class="text-14" [innerHTML]="'common-app.__EXPLANATORY_FACTORS_INFO_TEXT' | AsyncLang | async "></app-text>
        </div>
        <app-text role="footer" [text]="'common-app.__GOT_IT' | LANG" class="text-grey-70 text-16 is-family-semiBold is-cursor-pointer  is-fullwidth is-justify-center" (click)="setInfo()"></app-text>
      </app-information-popup>
            
      } 
      @if (hasExplanatoryFactors(vm.report)) {
        <app-cp-reports-factors-content></app-cp-reports-factors-content>
      } 
      @else {
        <div class="no-data">
          <div class="content-no-data">
            <img src="/assets/images/control-page/rectangular_medium-general-missingData.svg">
            <app-text class="is-family-semiBold text-18 text-grey-90 is-justify-center has-spacing-s has-spacing-top-m" [text]="'common-app.__MISSING_DATA' | AsyncLang | async"></app-text>
    
            <app-text class="is-family-regular text-16 text-grey-90 is-justify-center has-spacing-s text-align-center" [text]="'common-app.__EXPLANATORY_FACTORS_MISSING_DATA_TEXT' | AsyncLang | async"></app-text>
          </div>
          @if(isInfoOpen()) {
            <app-information-popup>
              <div role="content">
                <app-text class="text-18 is-family-semiBold has-spacing-bottom-xl is-justify-center">{{'common-app.__EXPLANATORY_FACTORS_INFO_TITLE' | AsyncLang | async }}</app-text>
                <app-text class="text-14" [innerHTML]="'common-app.__EXPLANATORY_FACTORS_INFO_TEXT' | AsyncLang | async "></app-text>
              </div>
              <app-text  class="is-fullwidth" role="footer" [text]="'common-app.__GOT_IT' | LANG" class="text-grey-70 text-16 is-family-semiBold is-cursor-pointer  is-fullwidth is-justify-center" (click)="setInfo()"></app-text>
            </app-information-popup>
                
          }       
        </div>
      }
     
  </div>
</ng-container>
